import AgoToast from '../../components/Toast/AgoToast';
import { ProducerService } from '../../service/producers/producer.service';
import { DownloadFormat } from '../../pages/map/types/Shapefiles';
import { getAllGroups } from './data-collection-action';
import { API } from '../../service/common/api';
import { BASE_URL } from '../../service/common/env';

export const getProducersListAndFieldGroupsAction: any = (isAuditor: boolean) => (dispatch: any) => {
  return getAllGroups(dispatch).then(() => {
    return getProducerListAction(dispatch, isAuditor);
  });
};

export const getProducerListAction: any = async (dispatch: any, isAuditor: boolean) => {
  dispatch({
    type: 'GET_PRODUCER_LIST_REQUESTED',
  });
  return ProducerService.getProducerList(isAuditor)
    .then((res: any) => {
      dispatch({
        type: 'GET_PRODUCER_LIST_SUCCEEDED',
        payload: res,
      });
    })
    .catch((err: any) => {
      dispatch({
        type: 'GET_PRODUCER_LIST_ERROR',
        payload: err,
      });
      AgoToast.showToast({
        title: 'Error loading Producers',
        message: err.message,
        type: 'error',
        toastId: 'lead-request',
      });
    });
};

export const getProducerByIdAction: any =
  (growerId: string, getJourney = false) =>
  (dispatch: any) => {
    dispatch({
      type: 'GET_PRODUCER_BY_ID_REQUESTED',
    });
    return ProducerService.getProducerById(growerId)
      .then((res: any) => {
        dispatch({
          type: 'GET_PRODUCER_BY_ID_SUCCEEDED',
          payload: res,
        });
        if (getJourney) {
          return API.post(`${BASE_URL}/base/producer`, {
            leadId: res.leadId,
            opportunityId: res.opportunityId,
          }).then((res) => {
            const journey = {
              ...res.data,
              id: res.data.journeyId,
            };

            dispatch({
              type: 'GET_JOURNEY_BY_ID_SUCCEEDED',
              payload: journey,
            });
          });
        }
        return res;
      })
      .catch((err: any) => {
        dispatch({
          type: 'GET_PRODUCER_BY_ID_ERROR',
          payload: err,
        });
        AgoToast.showToast({
          title: 'Error getting producer information',
          message: err.message,
          type: 'error',
          toastId: 'lead-request',
        });
      });
  };

export const getJourneyByIdAction: any = (journeyId: string) => (dispatch: any) => {
  dispatch({
    type: 'GET_JOURNEY_BY_ID_REQUESTED',
  });
  return ProducerService.getJourneyById(journeyId)
    .then((res: any) => {
      dispatch({
        type: 'GET_JOURNEY_BY_ID_SUCCEEDED',
        payload: res,
      });
      return res;
    })
    .catch((err: any) => {
      dispatch({
        type: 'GET_JOURNEY_BY_ID_ERROR',
        payload: err,
      });
      AgoToast.showToast({
        title: 'Error getting journey information',
        message: err.message,
        type: 'error',
        toastId: 'journey-request',
      });
    });
};

export const clearProducerStore: any = () => (dispatch: any) => {
  dispatch({
    type: 'CLEAR_PRODUCER_STORE',
  });
};

export const downloadBoundariesAction: any = (selectedProducers: { [key: string]: string | null }, type: DownloadFormat) => (dispatch: any) => {
  dispatch({
    type: 'DOWNLOAD_BOUNDARIES_REQUESTED',
  });
  return ProducerService.downloadProducerBoundaries(selectedProducers, type)
    .then((res: any) => {
      dispatch({
        type: 'DOWNLOAD_BOUNDARIES_SUCCEEDED',
        payload: res,
      });
      return res;
    })
    .catch((err: any) => {
      dispatch({
        type: 'DOWNLOAD_BOUNDARIES_ERROR',
        payload: err,
      });
      AgoToast.showToast({
        title: 'Error downloading boundaries',
        message: err.message,
        type: 'error',
        toastId: 'journey-request',
      });
    });
};
